import Seo from "@/components/site/Seo";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/motion";
import { SectionHeading, CTABanner } from "@/components/site/Blocks";
import { values } from "@/data/content";

export default function About() {
  return (
    <>
      <Seo title="About Us" description="Immistop is a boutique Ahmedabad-based immigration advisory serving professionals, investors and families with discretion, integrity and precision." />
      <PageHero eyebrow="About Immistop" lines={["A bridge between", <em key="e" className="italic text-gold">where you are</em>, "and where you belong."]} image="/img/london-aerial.jpg" testid="about-hero" />

      <section className="bg-ivory section-lux" data-testid="about-story">
        <div className="container-lux grid gap-24 lg:grid-cols-2 lg:gap-28">
          <div>
            <SectionHeading eyebrow="Our Story" lines={["Founded on", "a simple belief."]} />
            <Reveal className="lede mt-14 space-y-8 text-charcoal">
              <p>Immistop Global Migration Advisory was founded in Ahmedabad on the conviction that a move abroad deserves the same discretion and rigour as any significant financial or family decision.</p>
              <p>Too often, migration advice is transactional — a form to complete, a fee to pay. We chose a different path: a boutique practice that takes on a considered number of clients, assigns senior advisers to every matter and tells each client the truth about their options.</p>
              <p>Our crest — a bridge — reflects what we do. We connect people to the places where their next chapter begins, with every span carefully engineered.</p>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="relative">
            <div className="aspect-[16/11] overflow-hidden"><img src="/img/about-founders.jpg" alt="The Immistop advisory team" loading="lazy" className="h-full w-full object-cover object-[center_35%]" /></div>
            <div className="relative -mt-12 ml-6 max-w-xs bg-navy p-8 text-ivory md:ml-auto md:mr-10">
              <p className="eyebrow-light">Our Vision</p>
              <p className="mt-4 font-serif text-2xl leading-snug">To be India's most trusted private advisory for global mobility.</p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-navy py-24 text-ivory md:py-32" data-testid="about-values">
        <div className="container-lux">
          <SectionHeading light eyebrow="Our Values" lines={["The principles", "we practise."]} />
          <div className="mt-24 grid gap-x-14 gap-y-16 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.08} className="border-t border-gold/25 pt-10">
                <p className="font-serif text-5xl font-light italic text-gold md:text-6xl">{v.title}</p>
                <p className="mt-8 text-[16px] font-light leading-relaxed text-ivory/80">{v.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </>
  );
}
